import request from '@/utils/request';
//优惠券列表
export function getOrderDetail(values) {
  return request('/ec/order/queryOrderDetail', {
    method: 'POST',
    data: values,
  });
}
